import React from 'react';
import styled from 'styled-components';
import VerticalBarChart from '../comp/VerticalBarChart'; // Assume this component exists
import { cores, coresGrafico } from '../../../../styles/styleUtils';

const ChartsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr; // Two equal columns
  gap: 30px;

  @media (max-width: 992px) {
    // Stack charts below 992px
    grid-template-columns: 1fr;
  }
`;

const ChartWrapper = styled.div`
  background-color: ${cores.branco};
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;

const FilterText = styled.p`
  font-size: 0.8rem;
  color: ${cores.cinzaMedio};
  margin-top: 15px;
  text-align: center;
`;

const options = {
  chart: { id: 'vendas-realizadas', toolbar: { show: false } },
  xaxis: { categories: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12] },
  colors: coresGrafico,
  plotOptions: { bar: { columnWidth: '60%', borderRadius: 4 } },
  dataLabels: {
    enabled: false,
    formatter: (val) =>
      val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    style: { fontSize: '11px' },
  },
  tooltip: {
    y: {
      formatter: (val) =>
        val.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
    },
  },
  legend: { position: 'top', horizontalAlign: 'right' },
};


const ChartsSection = ({ data }) => {
  return (
    <ChartsContainer>
      <ChartWrapper>
        <VerticalBarChart
          chartId="vendas-realizadas-chart"
          title="Vendas Realizadas"
          options={options}
          series={data.vendas?.series}
          type="bar"
          height={350}
        />
      </ChartWrapper>
      <ChartWrapper>
        <VerticalBarChart
          chartId="recebidos-chart"
          title="Recebidos"
          options={options}
          series={data.receitas?.series}
          type="bar"
          height={350}
        />
      </ChartWrapper>
    </ChartsContainer>
  );
};

export default ChartsSection;
